import React, { Fragment, useContext, useEffect, useState } from 'react';
import { P } from '../../../../AbstractElements';
import { Availability, AddToCart, InStock, OutOfStock, Point, Weight } from '../../../../Constant';
import ProductContext from '../../../../_helper/Ecommerce/Product';
import StarRatings from './StarRating';
import { Row, Col, Card, CardBody } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import ColorSelector from './ColorSelector';
import BrandShipping from './BrandShipping';
import { toast } from 'react-toastify';
import { postCart } from '../../../../CommonUrl';
import { postDataWithToken } from '../../../../Utils/restUtils';


const ProductDetails = ({ apiDetail, onAttributeImageChange }) => {
    const { symbol } = useContext(ProductContext);
    const navigate = useNavigate();
    const [selectedColors, setSelectedColors] = useState({});
    const [selectedRadio, setSelectedRadio] = useState({});
    const [selectedCheck, setSelectedCheck] = useState([]);
    const [selectedDropdownOptions, setSelectedDropdownOptions] = useState([]);
    const [attributeOption, setAttributeOption] = useState([]);
    const [qty, setQty] = useState(() => apiDetail?.min_order ?? 1);
    const [loading, Setloading] = useState(false);
    const isLogin=localStorage.getItem('login')


    useEffect(() => {
        if (onAttributeImageChange && attributeOption.length > 0) {
            onAttributeImageChange(attributeOption);
        }
    }, [attributeOption]);

    useEffect(() => {
        if (apiDetail?.min_order) {
            setQty(apiDetail.min_order);
        }
    }, [apiDetail]);

    const itemRate = apiDetail?.item_rate ? parseFloat(apiDetail.item_rate.replace(/,/g, '')) : 0;
    const minOrder = apiDetail?.min_order || 1;
    const unitPrice = itemRate / minOrder;
    const basePrice = unitPrice * qty;
    const extraPrice = attributeOption.length ? attributeOption.reduce((sum, item) => sum + (Number(item.price) || 0), 0) * qty : 0;
    const totalPrice = basePrice + extraPrice;

    const handleAddToCart = async () => {
        Setloading(true)
        if(!isLogin)
        {
            toast.warn("Please Login ")
            Setloading(false)
            return
        }
        const hasColor = apiDetail?.attributes?.color?.length ? Object.keys(selectedColors).length > 0 : true;
        const hasRadio = apiDetail?.attributes?.radio?.length ? Object.keys(selectedRadio).length > 0 : true;
        const hasCheckbox = apiDetail?.attributes?.checkbox?.length ? selectedCheck.length > 0 : true;
        const hasDropdown = apiDetail?.attributes?.dropdown?.length ? Object.keys(selectedDropdownOptions).length > 0 : true;

        if (hasColor && hasRadio && hasCheckbox && hasDropdown) {
            const attributeValues = attributeOption.map(item => item.id);
            const postRequest = { item_id: apiDetail.id, quantity: qty, option_ids: attributeValues }
            const response = await postDataWithToken(postCart, postRequest);
            if (response?.data?.status) {
                Setloading(false)
                navigate(`${process.env.PUBLIC_URL}/cart`);
            } else {
                toast.error(response?.data?.message);
            }
        } else {
            toast.error("Please select all required options.");
        }
        Setloading(false)
    };
    return (
        <Fragment>
            <Col xl="2" md="6" className="box-col-5 xl-50 proorder-lg-1">
                <Card className='p-10'>
                    <CardBody>
                        <div className="pro-group pt-0 border-0">
                            <StarRatings name={apiDetail?.name} />
                            <div className="product-price">B{symbol} {totalPrice}
                                {/* <del>{symbol}{Productdlt}</del> */}
                            </div>
                        </div>
                        <div className="pro-group"><P>{apiDetail?.description && apiDetail?.description}</P></div>
                        <ColorSelector
                            attributes={apiDetail?.attributes}
                            qty={qty}
                            setQty={setQty}
                            api={apiDetail}
                            options={setAttributeOption}
                            selectedColors={selectedColors}
                            setSelectedColors={setSelectedColors}
                            selectedRadio={selectedRadio}
                            setSelectedRadio={setSelectedRadio}
                            selectedCheck={selectedCheck}
                            setSelectedCheck={setSelectedCheck}
                            selectedDropdownOptions={selectedDropdownOptions}
                            setSelectedDropdownOptions={setSelectedDropdownOptions}
                        />
                        <div className="pro-group pt-0 border-0">
                            {/* <StarRatings name={apiDetail?.name} /> */}
                            <h4>Price:</h4>
                            <div className="product-price">B{symbol} {totalPrice}
                                {/* <del>{symbol}{Productdlt}</del> */}
                            </div>
                        </div>
                        <div className="pro-group">
                            <Row>
                                <Col md='6'>
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td><b>{Availability} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;</b></td>
                                                {apiDetail?.stock >= qty ?
                                                    <td className="txt-success">{InStock}</td>
                                                    : <td className="txt-danger">{OutOfStock}</td>
                                                }
                                            </tr>
                                            <tr>
                                                <td> <b>{Weight}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; :&nbsp;</b></td>
                                                <td>{apiDetail?.weight}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </Col>
                            </Row>
                        </div>
                        {/* <SocialIcons /> */}
                        <div className="pro-group pb-0">
                            <div className="pro-shop">
                                {
                                    loading ?
                                        <button class="btn btn-primary" type="button" disabled style={{width:'157px'}}>
                                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                            <span class="sr-only">Loading...</span>
                                        </button> :
                                        <button className="btn btn-primary" onClick={handleAddToCart}>
                                            <i className="fa fa-shopping-basket me-2"></i>
                                            {AddToCart}
                                        </button>

                                }
                                {/* <Link className='btn btn-primary' to={`${process.env.PUBLIC_URL}/cart`} > <i className="fa fa-shopping-basket me-2"></i>{AddToCart}</Link>&nbsp;&nbsp;&nbsp; */}
                                {/* <Link className='btn btn-danger' to={`${process.env.PUBLIC_URL}/app/ecommerce/wishlist`}> <i className="fa fa-heart me-2"></i>{AddToWishList} </Link> */}
                            </div>
                        </div>
                    </CardBody>
                </Card>
                {/* <BrandShipping /> */}
            </Col>
        </Fragment >
    );
};
export default ProductDetails;